/**
 * Framed Layout Component
 * Layout wrapper for iframe-based pages (embedding kidsland.com.cn)
 * 
 * This layout is different from the main Layout:
 * - html/body take full height
 * - iframe fills the entire viewport
 * - No footer (iframe content has its own footer)
 */
import React from 'react'
import { Global, css } from '@emotion/react'

const framedGlobalStyles = css`
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }
  html {
    overflow: hidden;
  }
  body {
    overflow: auto;
    font-family: 微软雅黑, 'Microsoft YaHei', sans-serif;
  }
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  * {
    box-sizing: border-box;
  }
`

interface FramedLayoutProps {
  children: React.ReactNode
}

const FramedLayout: React.FC<FramedLayoutProps> = ({ children }) => {
  return (
    <>
      <Global styles={framedGlobalStyles} />
      <main>{children}</main>
    </>
  )
}

export default FramedLayout
